"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import type { DiscoveryNavLinkView } from "@repo/sanity-utils/discoveryChrome";
import { DynamicIcon } from "./DynamicIcon";
import styles from "./DiscoveryHeaderNav.module.css";
type IconLink = Pick<DiscoveryNavLinkView, "iconUrl" | "lucideIcon">;

/**
 * Icon for a Discovery nav link. An uploaded image wins over a Lucide icon.
 */
export function DiscoveryNavLinkIcon(t0) {
  const $ = _c(16);
  const {
    link,
    variant
  } = t0;
  if (!link.iconUrl && !link.lucideIcon) {
    return null;
  }
  if (link.iconUrl) {
    const t1 = variant === "tile" ? styles.iconImage : styles.menuIconImage;
    const t2 = variant === "tile" ? 24 : 16;
    const t3 = variant === "tile" ? 24 : 16;
    let t4;
    if ($[0] !== link.iconUrl || $[1] !== t1 || $[2] !== t2 || $[3] !== t3) {
      t4 = <Image src={link.iconUrl} alt="" aria-hidden={true} className={t1} width={t2} height={t3} unoptimized={true} />;
      $[0] = link.iconUrl;
      $[1] = t1;
      $[2] = t2;
      $[3] = t3;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    const image = t4;
    if (variant === "tile") {
      let t5;
      if ($[5] !== image) {
        t5 = <span className={styles.iconTile}>{image}</span>;
        $[5] = image;
        $[6] = t5;
      } else {
        t5 = $[6];
      }
      return t5;
    }
    let t5;
    if ($[7] !== image) {
      t5 = <span className={styles.menuIcon}>{image}</span>;
      $[7] = image;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  if (!link.lucideIcon) {
    return null;
  }
  const t1 = variant === "tile" ? 24 : 16;
  let t2;
  if ($[9] !== link.lucideIcon || $[10] !== t1) {
    t2 = <DynamicIcon name={link.lucideIcon} size={t1} strokeWidth={1.5} aria-hidden={true} />;
    $[9] = link.lucideIcon;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const icon = t2;
  if (variant === "tile") {
    let t3;
    if ($[12] !== icon) {
      t3 = <span className={styles.iconTile}>{icon}</span>;
      $[12] = icon;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    return t3;
  }
  let t3;
  if ($[14] !== icon) {
    t3 = <span className={styles.menuIcon}>{icon}</span>;
    $[14] = icon;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
}